/** Checks if the error is a chunk/module loading failure (network/timeout) */
export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  return error.name === "ChunkLoadError" || error.message.includes("Loading chunk") || error.message.includes("Loading CSS chunk");
}
